import { Eye, EyeSlash } from "iconsax-react";
import { ComponentProps, useState } from "react";
import { NumericFormat } from "react-number-format";
import { UseFormRegisterReturn } from "react-hook-form";
import { FieldError } from "react-hook-form";

type Props = {
  placeholder?: string;
  labelText?: string;
  type?: string;
  formObject?: UseFormRegisterReturn;
  errors?: FieldError;
  badge?: string | React.ReactNode;
  containerClass?: string;
  numericClass?: string;
  thousandSeparator?: boolean;
  labelTextClass?: string;
  badgeTextClass?: string;
} & ComponentProps<"input">;

function InputText({
  placeholder,
  labelText,
  type,
  containerClass,
  formObject,
  badge,
  errors,
  numericClass,
  thousandSeparator,
  labelTextClass,
  badgeTextClass,
  ...rest
}: Props) {
  const [passwordType, setPasswordType] = useState(false);
  const changeTypeHandler = () => {
    setPasswordType(!passwordType);
  };

  const spanClass = `absolute cursor-pointer top-[25%] right-4 `;
  const badgeClass = `absolute text-gray  top-[25%]  right-4 border-r`;

  return (
    <label className={`input-label  ${containerClass ? containerClass : ""}`}>
      {labelText && (
        <span
          className={`pr-1 inline-block label-text  ${
            labelTextClass ? labelTextClass : "font-bold text-sm"
          } `}
        >
          {labelText}
        </span>
      )}
      {thousandSeparator ? (
        <NumericFormat
          thousandSeparator={true}
          {...formObject}
          placeholder={placeholder ? placeholder : ""}
          {...rest}
          className={`number-input ${numericClass}`}
        />
      ) : (
        <input
          type={passwordType ? "text" : type}
          {...formObject}
          placeholder={placeholder ? placeholder : ""}
          {...rest}
        />
      )}

      {type === "password" && (
        <span onClick={changeTypeHandler} className={spanClass}>
          {!passwordType ? (
            <Eye size={25} color="#35393c" />
          ) : (
            <EyeSlash size={25} color="#35393c" />
          )}
        </span>
      )}
      {badge && (
        <span
          className={`${badgeClass} ${badgeTextClass ? badgeTextClass : ""}`}
        >
          {badge}
        </span>
      )}
      {errors && (
        <span className="text-ws-red-500 text-xs">{errors?.message}</span>
      )}
    </label>
  );
}

export default InputText;
